<template>
    <div class="privacy" :class="{'privacyDark': isDark}">
        <h3>隐私政策</h3>
        贵州嗨娱网络科技有限公司（以下简称“我们”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
        <p>请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。</p>
        <p>更新日期：2022年03月03日</p>
        <p>生效日期：2022年03月03日</p>

        <h5>第一部分  定义</h5>
        元体育：指元体育客户端
        <p>元体育运营主体：指元体育互联网信息及软件技术服务提供者，为贵州嗨娱网络科技有限公司。</p>
        <p>个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
        <p>个人敏感信息：指手机号码。</p>
        <p>个人删除信息：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>
        <p>设备信息：包括设备型号、操作系统版本、唯一设备标识码（IMEI号、AndroidID、GUID、OPENUDID、SIM卡IMSI、meid信息）、IP地址、软件版本号、网络接入方式及类型、网络设备硬件地址（MAC）信息。</p>
        <p>服务日志信息：您对我们服务的详细使用情况作为服务日志保存的信息，包括浏览、点击查看、以及IP地址、浏览器地址、电信运营商、使用语言、访问日期和时间。</p>
        <h5>第二部分  隐私政策</h5>
        <p>本隐私政策将帮助您了解以下内容：</p>
        <p>一、我们如何收集和使用您的信息</p>
        <p>二、我们如何使用cookie和同类技术</p>
        <p>三、我们如何共享、转让、公开披露您的信息</p>
        <p>四、我们如何保护您的信息</p>
        <p>五、您如何访问及控制您的个人信息</p>
        <p>六、我们如何保护未成年的信息</p>
        <p>七、本隐私政策的适用及更新</p>
        <p>八、如何联系我们</p>
        <h5>一、我们如何收集和使用您的个人信息</h5>
        我们会处于以下目的，收集和使用您的信息：
        <p><strong>（一）帮助您成为我们的平台用户</strong></p>
        <p>1.您注册、登录元体育时，我们将根据您的授权获取您的<strong>手机号码。若您拒绝提供第三方账号下的信息，则您无法选择使用第三方账号的方式注册并登录，我们承诺该类个人信息的第三方账号渠道来源的合法性。</strong></p>
        <p><strong>（二）保障产品、服务及用户使用安全</strong></p>
        <p>为帮助我们更好地了解“元体育”及相关服务的运行情况，以便确保运行与提供服务的安全，我们可能记录<strong>网络日志信息</strong>，以及使用软件及<strong>相关服务的频率、崩溃数据、总体安装、使用情况、性能数据</strong>等信息。</p>
        <p><strong>（三）为您提供安全保障</strong></p>
        <p>为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别会员账号异常状态，更好地保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或元体育相关协议规则的情况，我们在应用程序中嵌入应用安全SDK收集您的<strong>用户信息、设备信息、服务日志信息</strong>，并可能使用我们关联公司取得您授权或依据法律共享的信息，来综合判断您账号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
        <p><strong>（四）为您提供附加服务</strong></p>
        <p>我们向您提供的以下附加服务中可能会收集和使用您的个人信息。<strong>如果您不提供这些信息，不会影响您使用元体育的浏览等基本服务</strong>，但您可能无法获得这些附加服务给您带来的用户体验，这些附加服务包括：</p>
        <p><strong>1.基于日历的附加服务：</strong>在您开启我们可读取/写入您日历的权限后，我们将收集您的<strong>日历信息</strong>用于向您提供签到或者领取权益相关记录及提醒。</p>
        <p><strong>2.基于电话状态的附加服务：</strong>您需要授权我们读取<strong>本机识别码</strong>，用于保障您的账号与使用安全。</p>
        <p>您理解并同意上述附加服务可能需要您在您的设备中开启<strong>日历、电话状态的访问权限，</strong>已实现这些权限所涉及信息的收集和使用。<strong>请注意，您开启任一权限即代表您授权我们可以收集和使用和相关个人信息来为您提供对应服务，一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集和使用。</strong></p>
        <p><strong>（五）其他</strong></p>
        <p>1.若您提供的信息中含有其他用户的个人信息，再向元体育平台提供这些个人之前，您需确保已经取得合法的授权。</p>
        <p>2.若我们将信息用户本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</p>
        <p>3.征得授权同意的例外</p>
        <p>您充分理解并同意，根据相关法律法规规定，我们在以下情形中收集、使用您的个人信息无需征得您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：</p>
        <p>1）与国家安全、国防安全有关的；</p>
        <p>2）与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
        <p>5）所收集的个人信息是您自行向社会公众公开的；</p>
        <p>6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p>7）根据您的要求签订合同所必需的；</p>
        <p>8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
        <p>9）为合法的新闻报道所必需的；</p>
        <p>10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
        <p>11）法律法规规定的其他情形。</p>
        <p>请知悉，根据适用的法律，若我们<strong>对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善元体育的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），则此类处理后数据的使用无需另行向您通知并征得您的同意。</strong></p>
        <p>如我们停止运营元体育产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。</p>
        <p>在您主动注销账号时，我们将根据适用法律法规的要求尽快使其匿名或删除您的个人信息。</p>
        <h5>二、我们如何使用 Cookie 和同类技术</h5>
        Cookie和同类技术是互联网中的通用常用技术。当您使用“元体育”及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您在访问、使用“元体育”时的相关信息。我们使用Cookie和同类技术主要为了保障产品与服务的安全、高效运转，帮助您获得更轻松的访问体验。
        <p>我们可能会设置认证与保障安全性的cookie或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈等不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</p>
        <p>我们承诺，我们不会将Cookie用于本隐私政策所述目的之外的任何其他用途。</p>
        <h5>三、我们如何共享、转让、公开披露您的信息</h5>
        <strong>（一）共享</strong>
        <p>我们不会向其他任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
        <p>1.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
        <p>2.我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
        <p><strong>（二）转让</strong></p>
        <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <p>1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
        <p>2.在<strong>涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</strong></p>
        <p><strong>（三）公开披露</strong></p>
        <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
        <p>1.获得您明确同意后；</p>
        <p>2.基于法律的披露：<strong>在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</strong></p>
        <p><strong>（四）我们如何保护您的信息</strong></p>
        <p>1.我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
        <p>2.我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
        <p>3.互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他我们用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
        <p>4.互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
        <p>5.在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</p>
        <p>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
        <h5>五、您如何访问及控制您的个人信息</h5>
        按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
        <p><strong>（一）访问您的个人信息</strong></p>
        <p>您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</p>
        <p>账户信息——如果您希望访问或编辑您的账户中的个人资料信息、更改您的密码或绑定手机等，您可以通过点击【我】-【个人信息】执行此类操作。</p>
        <p>对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请与客服联系。我们将在十天内回复您的访问请求。</p>
        <p><strong>（二）更正您的个人信息</strong></p>
        <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问您的个人信息”中罗列的方式提出更正申请。如果您无法更正，请与客服联系。我们将在十天内回复您的更正请求。</p>
        <p><strong>（三）删除您的个人信息</strong></p>
        <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
        <p>1.如果我们处理个人信息的行为违反法律法规；</p>
        <p>2.如果我们收集、使用您的个人信息，却未征得您的同意；</p>
        <p>3.如果我们处理个人信息的行为违反了与您的约定；</p>
        <p>4.如果我们不再为您提供产品或服务。</p>
        <p><strong>若我们决定响应您的删除请求，我们还将同时通知从我们这里获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</strong></p>
        <p><strong>当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</strong></p>
        <p><strong>（四）约束信息系统自动决策</strong></p>
        <p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。</p>
        <p><strong>（五）响应您的上述请求</strong></p>
        <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
        <p>我们将在十天内做出答复。如您不满意，还可以通过客服投诉：</p>
        <p>对于您的合理请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
        <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
        <p>1.与国家安全、国防安全有关的；</p>
        <p>2.与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>3.与犯罪侦查、起诉和审判等有关的；</p>
        <p>4.有充分证据表明您存在主观恶意或滥用权利的；</p>
        <p>5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
        <h5>六、我们如何保护未成年的信息</h5>
        <p>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。</p>
        <p>对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</p>
        <p>尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。 如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>
        <h5>七、本隐私政策的适用及更新</h5>
        <p>我们根据法律可能会适时对本隐私权政策进行调整或变更，本隐私权政策的任何更新将以标注更新时间的方式公布在我们网站上，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表了您已充分阅读、理解并接受修改后的隐私权政策并受其约束。</p>
        <h5>八、如何联系我们</h5>
        <p>如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们客服联系：</p>
        <p>微信号：18611358844 手机号：18611358844</p>
        <p>一般情况下，我们将在七个工作日内回复。</p>
    </div>
</template>

<script>
export default {
    name: 'metaprivacy',
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        document.getElementsByTagName('title')[0].innerHTML = '隐私和条款';
    }
}
</script>

<style lang="less" scoped>
.privacy{
    width: 100%;
    padding: 10px 16px;
    font-size: 12px;
    color: #7d7d7d;
    line-height: 1.5;
    h3{
        font-size: 22px;
        font-weight: bold;
        color: #171717;
    }
    h5{
        font-size: 16px;
        font-weight: bold;
        color: #171717;
    }
}
.privacyDark{
    min-height: 100vh;
    background-color: #191919;
    color: #595959;
    h3, h5{
        color: #d3d3d3;
    }
}
</style>
